import { createAsyncThunk } from '@reduxjs/toolkit';
import { machineService } from 'services';

export const deleteMachine = createAsyncThunk<any, string>('machieEdit/deleteMachine', async (itemId) => {
  const response = await machineService.deleteMachine(itemId);
  return response;
});

export const deleteEquiment = createAsyncThunk<any, string>('machineEdit/deleteEquiment', async (param) => {
  const response = await machineService.deleteEquiment(param);
  return response;
});
